import React from 'react';
import { Col, Row, Tag } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useTheme } from 'hooks/useTheme';
import './sms.scss';

export const SMS_PAGE_CREDIT_COUNT = 1400;

export const SMSPageShell = ({ eyebrow, title, subtitle, creditLabel, creditCount = SMS_PAGE_CREDIT_COUNT, meta = [], children }) => {
	const { theme, themeColor } = useTheme();

	return (
		<div className={`sms-page sms-page--${theme}`.trim()} style={{ '--sms-accent': themeColor }}>
			<section className="sms-hero">
				<div className="sms-hero__copy">
					<span className="sms-hero__eyebrow">{eyebrow}</span>
					<h1 className="sms-hero__title">{title}</h1>
					<p className="sms-hero__subtitle">{subtitle}</p>
				</div>
				<div className="sms-hero__credit-card">
					<div className="sms-hero__credit-icon">
						<MessageOutlined />
					</div>
					<div>
						<span className="sms-hero__credit-label">{creditLabel}</span>
						<strong className="sms-hero__credit-value">{creditCount.toLocaleString('en-IN')}</strong>
					</div>
					<Tag className="sms-hero__credit-tag">SMS</Tag>
				</div>
			</section>

			{meta.length ? (
				<Row gutter={[16, 16]} className="sms-meta-grid">
					{meta.map((item) => (
						<Col xs={24} sm={12} xl={8} key={item.label}>
							<div className="sms-stat-card">
								<span className="sms-stat-card__label">{item.label}</span>
								<strong className="sms-stat-card__value">{item.value}</strong>
								{item.helper ? <span className="sms-stat-card__helper">{item.helper}</span> : null}
							</div>
						</Col>
					))}
				</Row>
			) : null}

			<div className="sms-page__content">{children}</div>
		</div>
	);
};

export const SMSPanel = ({ title, subtitle, extra = null, footer = null, className = '', children }) => (
	<section className={`sms-panel ${className}`.trim()}>
		<div className="sms-panel__header">
			<div>
				<h2 className="sms-panel__title">{title}</h2>
				{subtitle ? <p className="sms-panel__subtitle">{subtitle}</p> : null}
			</div>
			{extra ? <div className="sms-panel__extra">{extra}</div> : null}
		</div>
		<div className="sms-panel__body">{children}</div>
		{footer ? <div className="sms-panel__footer">{footer}</div> : null}
	</section>
);
